import React, { useCallback } from 'react'
import { addBehaviorsRecord } from '../../utils/BehaviorstatsHelp'
import MinusIcon from '../Icon/MinusIcon'
import PlusIcon from '../Icon/PlusIcon'

import styles from './num.module.css'

export default function NumStepper(props) {
    const {
        onAdd,
        onRemove,
        min = 0,
        max = 100,
        items,
        curProduct,
        color = 'var(--adm-color-primary)',
        options = {},
        addBehavior = false,
        place = ''
    } = props

    const item = items?.find(item => item.productId === curProduct.productId && item.specsKey === curProduct.specsKey && item.attrKeys === curProduct.attrKeys && item.subAttrKeys === curProduct.subAttrKeys)
    const value = item?.quantity || 0

    const addBehaviorLog = ({ actionStr }) => {
        if (!addBehavior) return
        addBehaviorsRecord({
            behaviorType: 160200,
            behavior: 160209,
            value1: curProduct.productId,
            value2: actionStr,
            value3: place,
        })
    }

    const handleMinus = useCallback(() => {
        if (value > min) {
            onRemove(curProduct.productId, value, curProduct)
            addBehaviorLog({ actionStr: '-' })
        }
    }, [value, min, curProduct, onRemove])

    const handlePlus = useCallback(() => {
        if (value < max) {
            onAdd(item || curProduct)

            addBehaviorLog({ actionStr: '+' })
        }
    }, [value, max, curProduct, onAdd, item])

    const iconColor = options.iconColor || color
    const labelColor = options.labelColor
    const flexDirection = options.flexDirection

    return (
        <div className={`${styles.numStepper} jm-stepper-wrapper`} style={{ flexDirection, flexFlow: options.flexFlow }}>
            {
                value > 0 &&
                <>
                    <div>
                        <button onClick={handleMinus} >
                            <MinusIcon width={24} height={24} color={iconColor} />
                        </button>
                    </div>
                    <div
                        className={`jm-stepper-value ${styles.numStepperValue} `}
                        style={{ color: labelColor }}
                    >
                        {value}
                    </div>
                </>
            }

            <div>
                <button onClick={handlePlus} >
                    <PlusIcon width={24} height={24} color={value < max ? iconColor : "var(--adm-color-light)"} />
                </button>
            </div>

        </div>
    )
}
